module.exports = __webpack_public_path__ + "static/img/4.32c858f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Proteccion-digital-Empresas/4.png
// module id = w0jK
// module chunks = 0